import { getLocalStorageItemAsString, setLocalStorageItem } from '@atlassian/search-common';

import { logger } from '../logger';

const PREFIX = '@atlassian.search-ai.';

const setString = (key: string, value: string): void => {
	try {
		setLocalStorageItem(`${PREFIX}${key}`, value);
	} catch (error) {
		logger.error({ error, functionName: 'setString' });
	}
};

const getString = (key: string): string | null => {
	return getLocalStorageItemAsString(`${PREFIX}${key}`);
};

export const localStore: {
    getString: (key: string) => string | null;
    setString: (key: string, value: string) => void;
} = {
	getString,
	setString,
};
